import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import Layout from '@/pages/layout';
import home from './home';
import mine from './mine';
import project from './project';
import event from './event';
import serviceMall from './serviceMall';
import repair from './repair';
import { apifakelogin, apisystemsettingByCode } from '@/api';
import { install } from '@/utils/wxConfig';
import { anonymousLogin } from '@/utils/anoymousLogin';
Vue.use(Router);
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
var router = new Router({
  routes: [{
    path: '/',
    redirect: '/home',
    name: 'Layout',
    component: Layout,
    children: [].concat(_toConsumableArray(home), _toConsumableArray(project), _toConsumableArray(mine), _toConsumableArray(event), _toConsumableArray(serviceMall), _toConsumableArray(repair))
  }, {
    path: '/binding',
    name: 'Binding',
    meta: {
      name: i18n.tc("5")
    },
    component: function component() {
      return import('@/pages/LoginBind');
    }
  }, {
    path: '/login',
    name: 'Login',
    props: function props(route) {
      return route.query;
    },
    component: function component() {
      return import('@/pages/Login');
    },
    meta: {
      name: i18n.tc("6")
    }
  }, {
    path: '/register',
    name: 'Register',
    component: function component() {
      return import('@/pages/Register');
    },
    props: function props(route) {
      return {
        type: route.query.type,
        mobile: route.query.mobile
      };
    },
    meta: {
      name: i18n.tc("7")
    }
  }, {
    path: '/error/enterprise',
    name: 'ErrorEnterprise',
    component: function component() {
      return import('@/pages/ErrorEnterprise');
    },
    meta: {
      name: i18n.tc("8")
    }
  }, {
    path: '*',
    redirect: '/'
  }]
});
var whitelist = ['Login', 'Register', 'Binding', 'ErrorEnterprise'];
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var loadingMask, productPage, isProductPageNeedLogin, res, epLoginActions, cusLoginActions, isEpLogin, enterprise, user, isAnonymous, _enterprise, _user, isAnonymousEval, _res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log('AutoConsole ~ to:', to);
            loadingMask = document.getElementById('loadingDiv');
            if (loadingMask) loadingMask.parentNode.removeChild(loadingMask);
            Vue.prototype.$tpLoadingTar.start();
            productPage = 'Product';
            isProductPageNeedLogin = false;
            if (whitelist.includes(to.name)) {
              _context.next = 11;
              break;
            }
            _context.next = 9;
            return apisystemsettingByCode({
              code: 40023
            });
          case 9:
            res = _context.sent;
            if (res.success) {
              isProductPageNeedLogin = Boolean(+res.data.value);
            }
          case 11:
            // 需企业登录页面
            epLoginActions = ['FAQDetail', 'FAQ', 'Register',
            // 注册
            'Home',
            // 首页
            'ServiceItem',
            // 服务项目列表
            'ServiceDetail',
            // 服务项目详情
            'NoticeList',
            // 公告列表
            'NoticeDetail' // 公告详情
            ]; // 需账号密码登录页
            cusLoginActions = ['Mine',
            // 我的
            'Project',
            // 工单列表
            'ProjectDetail',
            // 工单详情
            'EventDetail', 'AppointmentEvent', 'UpdatePwd',
            // 更新密码
            'AddressAdd',
            // 添加地址
            'AddressList',
            // 地址列表
            'Appointment',
            // 预约工单列表
            'GroupList',
            // 人员列表
            'GroupPerson',
            // 人员详情
            'RepairApply', 'RepairRecord', 'shoppingCart', 'ServiceMallMine', 'AppointmentEvent'];
            if (isProductPageNeedLogin) {
              cusLoginActions.push(productPage);
            } else {
              epLoginActions.push(productPage);
            }
            if (!([].concat(epLoginActions, cusLoginActions).indexOf(to.name) !== -1)) {
              _context.next = 41;
              break;
            }
            isEpLogin = store.state.globalStore.user ? Object.keys(store.state.globalStore.user).length === 0 : false; // 企业登录
            if (!isEpLogin) {
              _context.next = 22;
              break;
            }
            if (!(process.env.NODE_ENV !== 'production')) {
              _context.next = 20;
              break;
            }
            _context.next = 20;
            return apifakelogin().catch(function (e) {
              return console.log(e);
            });
          case 20:
            _context.next = 22;
            return store.dispatch('globalStore/_ApiSession');
          case 22:
            _context.next = 24;
            return store.dispatch('globalStore/_ApiEnterprise');
          case 24:
            // 获取企业信息

            try {
              enterprise = store.state.globalStore.enterprise;
              if (enterprise.is_wx_auth) {
                install(Vue);
              }
            } catch (error) {
              console.log('AutoConsole: error', error);
            }
            user = store.state.globalStore.user;
            if (!(epLoginActions.indexOf(to.name) !== -1)) {
              _context.next = 30;
              break;
            }
            // 企业登录页面
            next();
            _context.next = 39;
            break;
          case 30:
            if (!(cusLoginActions.indexOf(to.name) !== -1)) {
              _context.next = 39;
              break;
            }
            if (!(user.id && user.id !== -1)) {
              _context.next = 35;
              break;
            }
            // 客户账号已登录
            next();
            _context.next = 39;
            break;
          case 35:
            _context.next = 37;
            return anonymousLogin();
          case 37:
            isAnonymous = _context.sent;
            if (isAnonymous) {
              next();
            } else {
              next({
                name: 'Login',
                query: {
                  path: to.fullPath
                }
              });
            }
          case 39:
            _context.next = 59;
            break;
          case 41:
            if (!(to.name === 'ProjectDetailComment' || to.name === 'EventDetailComment')) {
              _context.next = 58;
              break;
            }
            if (!(Object.keys(store.state.globalStore.user).length === 0)) {
              _context.next = 45;
              break;
            }
            _context.next = 45;
            return store.dispatch('globalStore/_ApiSession');
          case 45:
            if (!(Object.keys(store.state.globalStore.enterprise).length === 0)) {
              _context.next = 48;
              break;
            }
            _context.next = 48;
            return store.dispatch('globalStore/_ApiEnterprise');
          case 48:
            try {
              _enterprise = store.state.globalStore.enterprise;
              if (_enterprise.is_wx_auth) {
                install(Vue);
              }
            } catch (error) {
              console.log('AutoConsole: error', error);
            }
            _user = store.state.globalStore.user; // console.log(user)
            // let enterprise = store.state.globalStore.enterprise
            isAnonymousEval = 0;
            _context.next = 53;
            return apisystemsettingByCode({
              code: 40001
            });
          case 53:
            _res = _context.sent;
            // 获取匿名评价是否开启
            if (_res.success) {
              isAnonymousEval = +_res.data.value;
            }
            if (!(_user.type === 1 &&
            // 评价单进入
            isAnonymousEval === 0 &&
            // 未开启匿名评价
            _user.id === -1 // 未登录
            )) {
              _context.next = 58;
              break;
            }
            next({
              path: '/login'
            });
            return _context.abrupt("return");
          case 58:
            next();
          case 59:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to, from) {
  if (!to.name || to.name === 'Error') {
    Vue.prototype.$tpLoadingTar.error();
  } else {
    Vue.prototype.$tpLoadingTar.finish();
    store.commit('globalStore/_isInMain', ['Home', 'Project', 'Mine'].includes(to.name));
    // document.title = to.meta.name
  }
});
export default router;